import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getPhotoCaptureCompanyCode, RepairSelectShopComponent, getPhotoCaptureCountryCode, photoCaptureUpdateContextDataAction, getPhotoCaptureAttachmentInfo, getPhotoCaptureIsTermsAndConditionAccepted, getPhotoCaptureContextId, getPhotoCaptureAssignmentType, getPhotoCaptureAssignmentSubType, photoCapturePhotoUploadAction, getPhotoCaptureFraudWarningAccept, photoCaptureShopSelectionScreenVisitedAction, getResourceDetails } from "../../../domain/photoCapture";
import { getGPCTheme } from '../selectors';
import { getGPCEvaluationDocId } from '../utilities';
const mapStateToProps = (state) => {
    return {
        appTheme: getGPCTheme(state),
        countryCode: getPhotoCaptureCountryCode(state),
        companyCode: getPhotoCaptureCompanyCode(state),
        resourceDetails: getResourceDetails(state),
        photoCaptureAttachmentInfo: getPhotoCaptureAttachmentInfo(state),
        evaluationDocId: getGPCEvaluationDocId(state),
        isTermsAndConditionAccepted: getPhotoCaptureIsTermsAndConditionAccepted(state),
        contextId: getPhotoCaptureContextId(state),
        assignmentType: getPhotoCaptureAssignmentType(state),
        assignmentSubType: getPhotoCaptureAssignmentSubType(state),
        fraudWarningAccept: getPhotoCaptureFraudWarningAccept(state)
    };
};
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        photoCaptureUpdateContextDataAction,
        photoCapturePhotoUploadAction,
        photoCaptureShopSelectionScreenVisitedAction
    }, dispatch);
};
export const ConnectedRepairSelectShopComponent = connect(mapStateToProps, mapDispatchToProps)(RepairSelectShopComponent);
//# sourceMappingURL=ConnectedRepairSelectShopComponent.js.map